// extracted by mini-css-extract-plugin
export default {"info-icon":"R9DsC","infoIcon":"R9DsC"};